angular.module('lf.desktop')

.controller('CheckoutPaymentCtrl', function ($scope, helpers, preloadData, checkoutService, vindiciaService) {

  $scope.cards = lf.data.checkoutData.paymentData.creditCards || [];
  
  $scope.selectedCard = _.where($scope.cards, {isSelected: true})[0] ||
                        _.where($scope.cards, {isDefault: true})[0];
  
  $scope.hasCards = function () {
    return $scope.cards && $scope.cards.length;
  }
  
  $scope.selectCard = function (card) {
    if (card === $scope.selectedCard) return;
    
    $scope.selectedCard = card;
    
    $scope.cards.forEach(function (card) {
      card.isSelected = false;
    });
    card.isSelected = true;

    checkoutService.applyPaymentInformation({
      creditcardId: card.id
    })
      .success(function (applyPaymentInformationResponse) {
        if (applyPaymentInformationResponse.data.success) {
          console.log("Payment method ('"+card.id +"') was applied to the order.");
        } else {
          console.log("Error occured while applying Payment method ('"+card.id +"') to the order.");
        }
      })
      .error(function (applyPaymentInformationResponse) {
        console.log("Error occured while applying Payment method ('"+card.id +"') to the order.");
      });
  }
  
  var dummyCreditCard = {
      accountHolderName : 'John Doe',
      number: '4444444444444448',
      expires: {
        month: '02',
        year: 2017
      },
      cvn: '888',
      billingAddress1: 'Loop St 1',
      billingAddress2: '',
      billingAddress3: '',
      billingAddressCity: 'San Jose',
      billingAddressState: 'CA',
      billingAddressPostalCode: '9999',
      billingAddressPhone: '5108887766',
  };
  
  $scope.showAddNewCardPopup = function () {
    _.extend($scope.newCard, dummyCreditCard);
    $scope.popups.show('add-payment-method-credit-card');

    $scope.webSessionId = null;
    
    vindiciaService.initializeWebSession()
      .success(function (data) {
        data = data.data;
        if (data.success) {
          $scope.webSessionId = data.webSessionId;
        }
        console.log('vindiciaService.initializeWebSession', data);
      });
  }
  
  $scope.newCard = {
    months: helpers.creditCardForm.getMonths(),
    years: helpers.creditCardForm.getYears()
  };
  
  $scope.addNewCard = function () {
    console.log('addNewCard', $scope.newCard);
    var form = $scope.newCard;

    vindiciaService.addOrEditCreditCard({
      webSessionId: $scope.webSessionId,
      accountHolderName: form.firstName + ' ' + form.lastName,
      creditCardNumber: form.number,
      creditCardExpirationMonth: form.expires.month,
      creditCardExpirationYear: form.expires.year,
      nameValueCvn: form.cvn,
      billingAddress1: form.billingAddress1,
      billingAddress2: form.billingAddress2,
      billingAddress3: form.billingAddress3,
      billingAddressCity: form.billingAddressCity,
      billingAddressState: {value: form.billingAddressState},
      billingAddressPostalCode: form.billingAddressPostalCode,
      billingAddressPhone: form.billingAddressPhone,
      saveCreditCardInfo: true,
      setAsDefaultCreditCard: false
    })
  }
  
});
